(function() {

  // ============================================
  // LANGUAGE DETECTION
  // ============================================
  const isEnglish = window.location.pathname.includes('/en');
  const LANG = isEnglish ? 'en' : 'fr';

  // ============================================
  // CONFIGURATION
  // ============================================
  const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbylx9dVSL-PXr2EpUuseRfsaNbHAae97RzarzdZhehMmF2FA1kOyeqa-q5I0c2k8lzC/exec';

  const PROFILE_NAMES = {
    fr: {
      "Peau déshydratée et barrière fragilisée": "Peau déshydratée et barrière fragilisée",
      "Peau terne et stress oxydatif urbain": "Peau terne et stress oxydatif urbain",
      "Peau sensible et réactive": "Peau sensible et réactive",
      "Peau en perte de fermeté et signes installés": "Peau en perte de fermeté et signes installés",
      "Peau équilibrée en prévention": "Peau équilibrée en prévention",
      "Peau sensibilisée et affaiblie": "Peau sensibilisée et affaiblie"
    },
    en: {
      "Peau déshydratée et barrière fragilisée": "Dehydrated Skin & Weakened Barrier",
      "Peau terne et stress oxydatif urbain": "Dull Skin & Urban Oxidative Stress",
      "Peau sensible et réactive": "Sensitive & Reactive Skin",
      "Peau en perte de fermeté et signes installés": "Loss of Firmness & Established Signs",
      "Peau équilibrée en prévention": "Balanced Skin in Prevention",
      "Peau sensibilisée et affaiblie": "Sensitized & Weakened Skin"
    }
  };

  const PRODUCT_NAMES = {
    fr: {
      "Gel Nettoyant": "Gel Nettoyant",
      "Sérum Vitamine C 10%": "Sérum Vitamine C 10%",
      "Crème Yeux": "Crème Yeux",
      "Protection SPF 50+": "Protection SPF 50+",
      "Baume Bonne Mine": "Baume Bonne Mine",
      "Baume Démaquillant": "Baume Démaquillant",
      "Sérum Pro-Rétinol 0,3%": "Sérum Pro-Rétinol 0,3%",
      "Crème Riche": "Crème Riche",
      "Crème Légère": "Crème Légère"
    },
    en: {
      "Gel Nettoyant": "Cleansing Gel",
      "Sérum Vitamine C 10%": "Vitamin C 10% Serum",
      "Crème Yeux": "Eye Cream",
      "Protection SPF 50+": "SPF 50+ Sun Protection Gel",
      "Baume Bonne Mine": "Glow Balm",
      "Baume Démaquillant": "Cleansing Balm",
      "Sérum Pro-Rétinol 0,3%": "0.3% Pro-Retinol Serum",
      "Crème Riche": "Rich Cream",
      "Crème Légère": "Light Cream"
    }
  };

  const BUNDLE_NAMES = {
    fr: {
      "Protocole Complet": "Protocole Complet",
      "Duo Serums Stimuler Protéger": "Duo Serums Stimuler Protéger",
      "Duo Serum Haute Concentration": "Duo Serum Haute Concentration",
      "Duo du Soir Haute Performance": "Duo du Soir Haute Performance"
    },
    en: {
      "Protocole Complet": "Complete Protocol",
      "Duo Serums Stimuler Protéger": "Stimulate & Protect Serums Duo",
      "Duo Serum Haute Concentration": "High Concentration Serum Duo",
      "Duo du Soir Haute Performance": "High Performance Evening Duo"
    }
  };

  const MOMENT_LABELS = {
    fr: { "MATIN": "MATIN", "24/7": "24/7", "SOIR": "SOIR" },
    en: { "MATIN": "MORNING", "24/7": "24/7", "SOIR": "EVENING" }
  };

  const PRODUCT_MAPPING = {
    "Gel Nettoyant": { variantId: "52129211089243", price: 40, rating: 5.0, moment: "MATIN", handle: "gel-nettoyant" },
    "Sérum Vitamine C 10%": { variantId: "47024007348571", price: 80, rating: 4.9, moment: "MATIN", handle: "serum-vitamine-c" },
    "Crème Yeux": { variantId: "47024007479643", price: 48, rating: 4.86, moment: "MATIN", handle: "creme-yeux-reparation-contour-des-yeux" },
    "Protection SPF 50+": { variantId: "51111063355739", price: 44, rating: 4.8, moment: "MATIN", handle: "protection-quotidienne-spf50" },
    "Baume Bonne Mine": { variantId: "47024007414107", price: 29, rating: 4.9, moment: "24/7", handle: "baume-bonne-mine" },
    "Baume Démaquillant": { variantId: "50082216739163", price: 50, rating: 4.0, moment: "SOIR", handle: "baume-demaquillant" },
    "Sérum Pro-Rétinol 0,3%": { variantId: "47024007512411", price: 95, rating: 5.0, moment: "SOIR", handle: "retinol-serum-concentre" },
    "Crème Riche": { variantId: "47024007446875", price: 85, rating: 4.9, moment: "SOIR", handle: "creme-riche-reparation-intense" },
    "Crème Légère": { variantId: "47764673757531", price: 80, rating: 4.8, moment: "SOIR", handle: "creme-legere-emulsion-hydratante" }
  };

  const BUNDLES_MAPPING = [
    { name: "Protocole Complet", variantId: "48153393070427", price: 342, originalPrice: 376, rating: 4.9, handle: "protocole-complet" },
    { name: "Duo Serums Stimuler Protéger", variantId: "51733968322907", price: 100, originalPrice: 137, rating: 4.5, handle: "duo-serums-stimuler-proteger" },
    { name: "Duo Serum Haute Concentration", variantId: "50122346660187", price: 157, originalPrice: 175, rating: 4.6, handle: "duo-serum-haute-concentration" },
    { name: "Duo du Soir Haute Performance", variantId: "50122604642651", price: 162, originalPrice: 180, rating: 5.0, handle: "duo-du-soir-haute-performance" }
  ];

  const DEFAULT_CHECKED_PRODUCTS = {
    "Peau déshydratée et barrière fragilisée":      ["Crème Riche", "Protection SPF 50+"],
    "Peau terne et stress oxydatif urbain":          ["Sérum Vitamine C 10%", "Protection SPF 50+"],
    "Peau sensible et réactive":                     ["Protection SPF 50+", "Crème Riche"],
    "Peau en perte de fermeté et signes installés":  ["Protection SPF 50+", "Sérum Pro-Rétinol 0,3%"],
    "Peau équilibrée en prévention":                 ["Sérum Vitamine C 10%", "Protection SPF 50+"],
    "Peau sensibilisée et affaiblie":                ["Protection SPF 50+", "Crème Riche"]
  };

  const MOMENT_INFO_FR = {
    "MATIN": "Protéger et préparer votre peau pour la journée",
    "24/7": "Embellir naturellement à tout moment",
    "SOIR": "Réparer et régénérer pendant la nuit"
  };

  const MOMENT_INFO_EN = {
    "MATIN": "Protect and prepare your skin for the day",
    "24/7": "Naturally enhance at any time",
    "SOIR": "Repair and regenerate overnight"
  };

  const MOMENT_INFO = LANG === 'en' ? MOMENT_INFO_EN : MOMENT_INFO_FR;

  const WHY_TEXTS_FR = {
    "Peau déshydratée et barrière fragilisée": "Vos réponses révèlent une barrière cutanée fragilisée — tiraillements, inconforts, réactivité aux changements de température. Priorité à un nettoyage doux, une protection antioxydante le matin et une réparation intensive le soir pour restaurer durablement l'équilibre.",
    "Peau terne et stress oxydatif urbain": "Vos réponses révèlent une peau qui manque d'éclat et cherche une formulation clean et performante. La Vitamine C 10% est le pilier de cette routine : elle neutralise les radicaux libres, unifie le teint et prépare la peau à absorber les actifs du soir.",
    "Peau sensible et réactive": "Vos réponses révèlent une peau naturellement sensible et sujette aux rougeurs, quelles que soient les conditions. Douceur avant tout : nettoyage non agressif, protection stricte au quotidien, et actifs qui renforcent progressivement la barrière sans la brusquer.",
    "Peau en perte de fermeté et signes installés": "Vos réponses révèlent une peau mature qui appelle une stimulation cellulaire active — et vous êtes prête à investir sérieusement. Vitamine C + SPF le matin, Sérum Pro-Rétinol 0,3% le soir pour relancer le collagène et raffermir les traits durablement.",
    "Peau équilibrée en prévention": "Vos réponses révèlent une peau globalement équilibrée, avec une préférence pour une routine simple et efficace. Vitamine C et SPF maintiennent l'éclat et préviennent les premiers signes de l'âge, avec un renfort possible au Pro-Rétinol selon vos envies.",
    "Peau sensibilisée et affaiblie": "Vos réponses révèlent une peau sensible qui présente aussi des signes de vieillissement — une combinaison qui demande une approche spécifique. Actifs doux et tolérants le matin, stimulation progressive le soir avec le Sérum Pro-Rétinol 0,3% formulé pour les peaux réactives.",
    "default": "Vos réponses révèlent une peau qui demande une attention particulière. Cette routine a été pensée pour vous apporter les actifs les plus adaptés à votre profil, dans le bon ordre et aux bons moments de la journée."
  };

  const WHY_TEXTS_EN = {
    "Peau déshydratée et barrière fragilisée": "Your answers reveal a weakened skin barrier — tightness, discomfort, or reactivity to temperature changes. Priority: a gentle cleanser, antioxidant protection in the morning, and intensive peptide repair at night to lastingly restore skin balance.",
    "Peau terne et stress oxydatif urbain": "Your answers reveal skin that lacks radiance and calls for clean, high-performance formulations. Vitamin C 10% is the cornerstone of this routine: it neutralizes free radicals, evens the complexion, and primes skin for evening actives.",
    "Peau sensible et réactive": "Your answers reveal naturally sensitive skin prone to redness, regardless of external conditions. Gentleness above all: a non-aggressive cleanser, strict daily protection, and actives that progressively strengthen the barrier without disrupting it.",
    "Peau en perte de fermeté et signes installés": "Your answers reveal mature skin that calls for active cellular stimulation — and you're ready to invest seriously. Vitamin C + SPF in the morning, Pro-Retinol Serum 0.3% at night to boost collagen synthesis and firm facial contours.",
    "Peau équilibrée en prévention": "Your answers reveal overall balanced skin, with a preference for a simple, effective daily routine. Vitamin C and SPF maintain your glow and prevent early signs of aging, with optional Pro-Retinol support at your own pace.",
    "Peau sensibilisée et affaiblie": "Your answers reveal sensitive skin with early signs of aging — a combination that calls for a specific approach. Gentle actives in the morning, progressive cellular stimulation at night with the 0.3% Pro-Retinol Serum formulated for reactive skin.",
    "default": "Your answers reveal skin that requires specific attention. This routine has been designed to deliver the most suitable actives for your profile, in the right order and at the right times of day."
  };

  const WHY_TEXTS = LANG === 'en' ? WHY_TEXTS_EN : WHY_TEXTS_FR;

  const UI_TEXTS = {
    fr: {
      selectProduct: 'Veuillez sélectionner au moins un produit',
      addingToCart: 'Ajout en cours...',
      freeShipping: 'Vous bénéficiez de la livraison gratuite',
      almostFreeShipping: 'Plus que',
      forFreeShipping: 'pour la livraison gratuite'
    },
    en: {
      selectProduct: 'Please select at least one product',
      addingToCart: 'Adding to cart...',
      freeShipping: 'You qualify for free shipping',
      almostFreeShipping: 'Only',
      forFreeShipping: 'away from free shipping'
    }
  };

  const T = UI_TEXTS[LANG];

  function translateProfileName(profileFR) { return PROFILE_NAMES[LANG][profileFR] || profileFR; }
  function translateProductName(productFR) { return PRODUCT_NAMES[LANG][productFR] || productFR; }
  function translateBundleName(bundleFR) { return BUNDLE_NAMES[LANG][bundleFR] || bundleFR; }
  function translateMoment(momentFR) { return MOMENT_LABELS[LANG][momentFR] || momentFR; }

  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get('email');
  let retryCount = 0;
  const MAX_RETRIES = 10;

  if (!email) { showError(); return; }

  fetchDiagnosticData();

  function fetchDiagnosticData() {
    fetch(`${SCRIPT_URL}?email=${encodeURIComponent(email)}`)
      .then(response => response.json())
      .then(data => {
        if (!data.profile) { showError(); return; }
        const now = new Date();
        const diagnosticDate = data.submitted_at ? new Date(data.submitted_at) : null;
        const ageInSeconds = diagnosticDate ? (now - diagnosticDate) / 1000 : Infinity;
        if (ageInSeconds === Infinity && retryCount < MAX_RETRIES) {
          retryCount++;
          setTimeout(fetchDiagnosticData, 500);
          return;
        }
        if (retryCount === 0 && ageInSeconds > 30) {
          displayResults(data.profile, data.products);
          return;
        }
        if (ageInSeconds > 30 && ageInSeconds < 120 && retryCount > 0 && retryCount < MAX_RETRIES) {
          retryCount++;
          setTimeout(fetchDiagnosticData, 500);
          return;
        }
        displayResults(data.profile, data.products);
      })
      .catch(error => {
        if (retryCount < MAX_RETRIES) { retryCount++; setTimeout(fetchDiagnosticData, 500); }
        else { showError(); }
      });
  }

  async function fetchProductVideo(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      if (product.media && product.media.length > 1) {
        const secondMedia = product.media[1];
        if (secondMedia.media_type === 'video' && secondMedia.sources && secondMedia.sources.length > 0) {
          return secondMedia.sources[0].url;
        }
      }
      return null;
    } catch (error) { return null; }
  }

  async function fetchProductImage(handle) {
    try {
      const response = await fetch(`/products/${handle}.js`);
      const product = await response.json();
      return product.featured_image || '';
    } catch (error) { return ''; }
  }

  async function displayResults(profileFR, productsStr) {
    document.getElementById('loading').style.display = 'none';
    document.getElementById('result').style.display = 'block';

    const profileTranslated = translateProfileName(profileFR);
    document.getElementById('hero-profile').textContent = profileTranslated;

    const whyText = WHY_TEXTS[profileFR] || WHY_TEXTS.default;
    document.getElementById('hero-why-text').textContent = whyText;

    const checkedProducts = DEFAULT_CHECKED_PRODUCTS[profileFR] || [];
    const productNames = productsStr.split('|').map(p => p.trim());
    const productsByMoment = {};

    productNames.forEach(nameFR => {
      const product = PRODUCT_MAPPING[nameFR];
      if (!product) return;
      if (!productsByMoment[product.moment]) productsByMoment[product.moment] = [];
      productsByMoment[product.moment].push({ ...product, nameFR, name: translateProductName(nameFR) });
    });

    const container = document.getElementById('products-container');
    const moments = ['MATIN', '24/7', 'SOIR'];

    for (const momentFR of moments) {
      if (!productsByMoment[momentFR]) continue;
      const momentTranslated = translateMoment(momentFR);
      const block = document.createElement('div');
      block.className = 'moment-block';
      block.innerHTML = `
        <div class="moment-header">
          <h3 class="moment-title">${momentTranslated}</h3>
          <p class="moment-description">${MOMENT_INFO[momentFR]}</p>
        </div>
        <div class="products-grid"></div>
      `;
      const grid = block.querySelector('.products-grid');
      const sortedProducts = [...productsByMoment[momentFR]].sort((a, b) => {
        return (checkedProducts.includes(a.nameFR) ? 0 : 1) - (checkedProducts.includes(b.nameFR) ? 0 : 1);
      });
      for (const product of sortedProducts) {
        const [videoUrl, productImage] = await Promise.all([fetchProductVideo(product.handle), fetchProductImage(product.handle)]);
        if (productImage) product.image = productImage;
        const isChecked = checkedProducts.includes(product.nameFR);
        const card = createProductCard(product, videoUrl, isChecked);
        grid.appendChild(card);
      }
      container.appendChild(block);
    }

    await displayBundles();
    updateTotal();

    document.getElementById('sticky-add-to-cart-btn').addEventListener('click', addToCart);

    // ============================================
    // STICKY BANNER — scroll visibility
    // Sur mobile : masquée après ATC, réapparaît au scroll down
    // ============================================
    let hasScrolled = false;
    let stickyHiddenAfterATC = false;
    let lastScrollY = window.scrollY;

    window.addEventListener('scroll', function() {
      const currentScrollY = window.scrollY;

      // Affichage initial après 100px de scroll
      if (!hasScrolled && currentScrollY > 100) {
        hasScrolled = true;
        document.querySelector('.sticky-banner').classList.add('visible');
      }

      // Sur mobile : réafficher la barre si l'user scroll down après ATC
      if (stickyHiddenAfterATC && window.innerWidth < 768) {
        if (currentScrollY > lastScrollY) {
          var stickyBanner = document.querySelector('.sticky-banner');
          if (stickyBanner) {
            stickyBanner.style.display = '';
            stickyHiddenAfterATC = false;
          }
        }
      }

      lastScrollY = currentScrollY;
    });

    // Exposer stickyHiddenAfterATC pour la fonction addToCart
    window._diagnosticStickyState = { setStickyHidden: function(v) { stickyHiddenAfterATC = v; } };
  }

  function createProductCard(product, videoUrl, isChecked) {
    const card = document.createElement('div');
    card.className = isChecked ? 'product-card selected' : 'product-card';
    card.innerHTML = `
      <div class="product-card-image-wrapper">
        <input type="checkbox" class="product-card-checkbox" ${isChecked ? 'checked' : ''}
          data-variant="${product.variantId}"
          data-price="${product.price}">
        <img src="${product.image}" alt="${product.name}" class="product-card-image">
        ${videoUrl ? `<video class="product-card-video" muted loop playsinline preload="metadata"><source src="${videoUrl}" type="video/mp4"></video>` : ''}
      </div>
      <div class="product-card-info">
        <span class="product-card-name">${product.name}</span>
        <div class="product-card-footer">
          <div class="product-card-prices">
            <span class="product-card-price">${product.price}€</span>
          </div>
          <div class="product-card-rating">
            <span class="product-card-star">★</span>
            <span>${product.rating}/5</span>
          </div>
        </div>
      </div>
    `;
    card.addEventListener('click', function(e) {
      if (e.target.type !== 'checkbox') {
        const checkbox = card.querySelector('.product-card-checkbox');
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change'));
      }
    });
    card.querySelector('.product-card-checkbox').addEventListener('change', function(e) {
      e.stopPropagation();
      card.classList.toggle('selected', this.checked);
      updateTotal();
    });
    if (videoUrl) {
      const video = card.querySelector('.product-card-video');
      card.addEventListener('mouseenter', () => video.play().catch(() => {}));
      card.addEventListener('mouseleave', () => { video.pause(); video.currentTime = 0; });
    }
    return card;
  }

  async function displayBundles() {
    const bundlesGrid = document.getElementById('bundles-grid');
    for (const bundle of BUNDLES_MAPPING) {
      const bundleImage = await fetchProductImage(bundle.handle);
      const card = createBundleCard(bundle, bundleImage);
      bundlesGrid.appendChild(card);
    }
  }

  function createBundleCard(bundle, image) {
    const card = document.createElement('div');
    card.className = 'bundle-card';
    const bundleNameTranslated = translateBundleName(bundle.name);
    card.innerHTML = `
      <div class="bundle-card-image-wrapper">
        <input type="checkbox" class="bundle-card-checkbox"
          data-variant="${bundle.variantId}"
          data-price="${bundle.price}"
          data-original-price="${bundle.originalPrice}">
        <img src="${image}" alt="${bundleNameTranslated}" class="bundle-card-image">
      </div>
      <div class="bundle-card-info">
        <span class="bundle-card-name">${bundleNameTranslated}</span>
        <div class="bundle-card-footer">
          <div class="bundle-card-prices">
            <span class="bundle-card-price">${bundle.price}€</span>
            <span class="bundle-card-price-original">${bundle.originalPrice}€</span>
          </div>
          <div class="bundle-card-rating">
            <span class="bundle-card-star">★</span>
            <span>${bundle.rating}/5</span>
          </div>
        </div>
      </div>
    `;
    card.addEventListener('click', function(e) {
      if (e.target.type !== 'checkbox') {
        const checkbox = card.querySelector('.bundle-card-checkbox');
        checkbox.checked = !checkbox.checked;
        checkbox.dispatchEvent(new Event('change'));
      }
    });
    card.querySelector('.bundle-card-checkbox').addEventListener('change', function(e) {
      e.stopPropagation();
      updateTotal();
    });
    return card;
  }

  function updateTotal() {
    let total = 0;
    let originalTotal = 0;
    let hasBundleSelected = false;
    document.querySelectorAll('.product-card-checkbox:checked').forEach(cb => { total += parseInt(cb.dataset.price); });
    document.querySelectorAll('.bundle-card-checkbox:checked').forEach(cb => {
      total += parseInt(cb.dataset.price);
      originalTotal += parseInt(cb.dataset.originalPrice);
      hasBundleSelected = true;
    });
    document.getElementById('sticky-total-price').textContent = total + '€';
    const originalPriceEl = document.getElementById('sticky-original-price');
    if (hasBundleSelected && originalTotal > total) {
      originalPriceEl.textContent = originalTotal + '€';
      originalPriceEl.style.display = 'inline';
    } else {
      originalPriceEl.style.display = 'none';
    }
    const shippingMessage = document.getElementById('shipping-message');
    if (total >= 100) {
      shippingMessage.textContent = T.freeShipping;
    } else {
      shippingMessage.textContent = `${T.almostFreeShipping} ${100 - total}€ ${T.forFreeShipping}`;
    }
  }

  async function addToCart() {
    const items = [];
    document.querySelectorAll('.product-card-checkbox:checked').forEach(cb => {
      items.push({ id: cb.dataset.variant, quantity: 1, properties: { '_diagnostic_source': 'typeform_quiz', '_diagnostic_email': email } });
    });
    document.querySelectorAll('.bundle-card-checkbox:checked').forEach(cb => {
      items.push({ id: cb.dataset.variant, quantity: 1, properties: { '_diagnostic_source': 'typeform_quiz', '_diagnostic_email': email } });
    });
    if (items.length === 0) { alert(T.selectProduct); return; }

    const btn = document.getElementById('sticky-add-to-cart-btn');
    const originalHTML = btn.innerHTML;
    btn.disabled = true;
    btn.style.opacity = '0.7';
    btn.style.cursor = 'not-allowed';
    btn.innerHTML = `<span class="btn-loading-spinner"></span> ${T.addingToCart}`;

    let successCount = 0;
    let failedItems = [];
    for (let i = 0; i < items.length; i++) {
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [items[i]] })
        }).then(response => {
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          return response.json();
        });
        successCount++;
      } catch (error) {
        failedItems.push(i + 1);
      }
    }

    btn.disabled = false;
    btn.style.opacity = '1';
    btn.style.cursor = 'pointer';
    btn.innerHTML = originalHTML;

    if (successCount > 0) {
      // Ajouter un attribut de panier pour identifier la commande comme issue du diagnostic
      // Cet attribut devient une "note attribute" sur la commande Shopify
      // → utilisé par Shopify Flow pour tagger automatiquement la commande
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: {
            'diagnostic_source': 'typeform_quiz',
            'diagnostic_profile': document.getElementById('hero-profile') ? document.getElementById('hero-profile').textContent : ''
          }
        })
      }).catch(function() {});

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: { product: {}, from_diagnostic: true }
      }));

      // ============================================
      // MOBILE ONLY : masquer la sticky bar après ATC
      // Elle réapparaîtra au prochain scroll down
      // ============================================
      if (window.innerWidth < 768) {
        var stickyBanner = document.querySelector('.sticky-banner');
        if (stickyBanner) stickyBanner.style.display = 'none';
        if (window._diagnosticStickyState) window._diagnosticStickyState.setStickyHidden(true);
      }
    }

    if (failedItems.length > 0) {
      console.warn(`${failedItems.length} produit(s) n'ont pas pu être ajoutés`);
    }
  }

  function showError() {
    document.getElementById('loading').style.display = 'none';
    document.getElementById('error').style.display = 'block';
  }

})();